import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { MessageService } from "primeng/api";
import { FileUpload } from "primeng/fileupload";

import { environment } from "../../../environments/environment";
import { FILE_UPLOAD } from "../../common/constant/fileupload.constant";
import { SessionService } from "../../common/services/session.service";
import { UserInterface } from "../user.interface";
import { UserService } from "../userService/api/user.service";
import { GLOBAL_CONSTANT } from "./../../common/constant/global.constant";

@Component({
  selector: "app-user-profile",
  templateUrl: "./user-profile.component.html",
  styleUrls: ["./user-profile.component.scss"],
  providers: [MessageService],
})
export class UserProfileComponent implements OnInit {
  userProfileData: any;
  userObj: UserInterface;

  Optiontypes: any;
  userStatus: any;
  userId: any;
  tabOneFlag: boolean = true;
  tabTwoFlag: boolean = false;
  tabThreeFlag: boolean = false;
  errorFlag: boolean = false;
  photo: any;
  photoFlag: boolean = false;
  profilePhoto: any;
  prefLangType: any[];
  selectedLanguage: any;
  recPassword = "";
  newPassword = "";
  confirmPassword = "";
  supportedLang: any;
  _entityName: string = "profileImage";
  previewImg: string = "assets/icons/userpro.png";
  profileError:boolean = false;
  picture:any;

  uploadAPI = FILE_UPLOAD.Profile_image;
  @ViewChild("imageUpload", { static: false }) imageUpload: FileUpload;
  uploadedFiles = [];
  apiBaseUrl = environment.API_BASE;
  filetype = FILE_UPLOAD.File_type;

  constructor(
    private userService: UserService,
    private sessionService: SessionService,
    private router: Router,
    private toast: MessageService
  ) {
    this.userObj = {};
    this.Optiontypes = GLOBAL_CONSTANT.ACTIVE_INACTIVE;
  }

  ngOnInit() {
    this.userId = this.sessionService.getUserInfo().id;
    this.getUserData();
    this.getSupportedLang();
  }

  getUserData() {
    this.userService.getUserInfo(this.userId).subscribe((res) => {
      this.userObj = res;

      this.userObj.status == true
        ? (this.userStatus = "1")
        : (this.userStatus = "0");

      this.userObj.dob !== null
        ? (this.userObj.dob = new Date(this.userObj.dob))
        : null;
      if (
        this.userObj.ProfileImage.length != 0 &&
        this.userObj.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this.userObj.ProfileImage);
        this.profilePhoto = this.photo[0].filename;
      }
      if (this.profilePhoto != null || this.profilePhoto != undefined) {
        this.photoFlag = true;
      }
    });
  }

  changeTab(tabNumber) {
    if (tabNumber === "tabOne") {
      this.tabOneFlag = true;
      this.tabTwoFlag = false;
      this.tabThreeFlag = false;
    } else if (tabNumber === "tabTwo") {
      this.tabOneFlag = false;
      this.tabTwoFlag = true;
      this.tabThreeFlag = false;
    } else if (tabNumber === "tabThree") {
      this.tabOneFlag = false;
      this.tabTwoFlag = false;
      this.tabThreeFlag = true;
    }
  }

  saveUser(data) {
    if (!data.valid) {
    } else {
      if (this.uploadedFiles.length >= 0) {
        this.imageUpload.upload();
        this.updateUser();
      } 
    }
  }
  saveProfile() {
    if (this.uploadedFiles.length >= 0) {
      this.imageUpload.upload();
    }
  }

  onUploadSuccess($event) {
    let d = $event.originalEvent.body.files;
    if (d && d.length != 0) {
      this.userObj.ProfileImage = JSON.stringify(d);
    } else {
      if (this.photo && this.photo != undefined) {
        this.userObj.ProfileImage = JSON.stringify(this.photo);
      } else {
        this.userObj.ProfileImage = JSON.stringify(d);
      }
    }
    if (this.userObj.ProfileImage) {
      if (
        this.userObj.ProfileImage.length != 0 &&
        this.userObj.ProfileImage != "[]"
      ) {
        this.photo = JSON.parse(this.userObj.ProfileImage);
        this.profilePhoto = this.photo[0].filename;
        if (this.profilePhoto.indexOf(this._entityName) > -1) {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/downloadS3?path=" +
            this.profilePhoto;
        } else {
          this.picture =
            this.apiBaseUrl +
            "/file-uploader/file2?path=" +
            this._entityName +
            `/${this.profilePhoto}`;
        }
      }
      
    }
  }

  onUploadError($event) {
    this.updateUser();
    this.profileError = true;
  }

  CheckPassword(passwordForm) {
    if (!passwordForm.valid) {
      return;
    } else {
      if (this.newPassword === this.confirmPassword) {
        this.errorFlag = false;
        let passObj = { id: this.userObj.id, password: this.newPassword };

        this.userService.changePaasword(passObj).subscribe((res) => {
          this.toast.add({
            severity: "success",
            summary: "Updated Successfully",
            detail: "Password Changed Successfully !!!",
          });
          this.router.navigate(["/login"]);
        });
      } else {
        this.errorFlag = true;
      }
    }
  }

  updateUser() {
    this.userService.updateUser(this.userObj).subscribe((res) => {
      this.sessionService.setUserInfo(res);
      this.toast.add({
        severity: "success",
        summary: "Updated Successfully",
        detail: "User Update Successfully !!!",
      });
      if (
        this.userObj.role === "SUPER_ADMIN" ||
        this.userObj.role === "OFFICE_ADMIN"
      ) {
        this.router.navigate(["/admin-dashboard"]);
      } else if (this.userObj.role === "KARYA_KARTA") {
        this.router.navigate(["/karyakarta/dashboard"]);
      } else {
        this.router.navigate(["/viewer-dashboard"]);
      }
    });
  }

  changeSupportedLang() {
    this.userService.saveChangedLanguage(this.selectedLanguage.id).subscribe(
      (res) => {
        this.getSupportedLang();
      },
      (err: any) => console.log(err)
    );
  }

  getSupportedLang() {
    this.userService.getSupportedLang().subscribe((res) => {
      this.supportedLang = res[0];
      this.selectedLanguage = this.supportedLang.filter(
        (ele: any) => ele.isActive === true
      )[0];
    });
  }

  cancel() {
    if (
      this.userObj.role === "SUPER_ADMIN" ||
      this.userObj.role === "OFFICE_ADMIN"
    ) {
      this.router.navigate(["/admin-dashboard"]);
    } else if (this.userObj.role === "KARYA_KARTA") {
      this.router.navigate(["/karyakarta/dashboard"]);
    } else {
      this.router.navigate(["/viewer-dashboard"]);
    }
  }
}
